import { AuthenticationError } from "@repo/web-auth"

export {
  ResetPasswordError,
  TokenRefreshUnavailableError,
} from "@repo/web-auth"

export default AuthenticationError

// Messages are translation keys; translate with useTranslateFieldError (or a
// root `t`) where they're shown, e.g. the login form.
class StoresNotFoundError extends Error {
  constructor() {
    super("alfred.lib.errors.storesNotFound")
  }
}

class StoreIdNotFoundError extends Error {
  constructor() {
    super("alfred.lib.errors.storeIdNotFound")
  }
}

class RoleNotFoundError extends Error {
  constructor() {
    super("alfred.lib.errors.roleNotFound")
  }
}

export { StoreIdNotFoundError, StoresNotFoundError, RoleNotFoundError }
